import type { TyreStatus } from '@chukua/common';
import type { TyreMoveKind } from './tyre-move.policy';

/**
 * The moves a tyre's own page offers for its status, mirroring the API's lifecycle table so a button is not shown for a move the server would
 * refuse. Fitting, replacing and rotating are offered from a vehicle's layout, where the vehicle and position are known. UX only: the server decides.
 */
export function availableTyreMoves(status: TyreStatus): TyreMoveKind[] {
  switch (status) {
    case 'fitted':
      return ['wear', 'mark-worn', 'repair', 'remove', 'scrap'];
    case 'worn':
      return ['wear', 'repair', 'remove', 'scrap'];
    case 'in_stock':
    case 'replaced':
      return ['retread', 'scrap'];
    case 'new':
      return ['scrap'];
    default:
      return [];
  }
}
